function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);

    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }

    ownKeys.forEach(function (key) {
      _defineProperty(target, key, source[key]);
    });
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

import React from 'react';
import { Tooltip } from '@nextiva/next-ui';
import TablePopover from "./TablePopover";
import defaultSettingsRenderer from "../helpers/settingsRenderer";
export default (function (props) {
  var _props$settingsRender = props.settingsRenderer,
      settingsRenderer = _props$settingsRender === void 0 ? defaultSettingsRenderer : _props$settingsRender;

  var body = function body(popoverProps) {
    return settingsRenderer(_objectSpread({}, popoverProps, props));
  };

  return React.createElement(TablePopover, {
    body: body
  }, React.createElement(Tooltip, {
    text: "Settings",
    delay: 1000
  }, React.createElement("span", {
    className: "nx-table__gear-icon"
  }, React.createElement("i", {
    className: "icon-custom-gear"
  }))));
});